import React, { useEffect, useState } from 'react';
import { Grid, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styles } from './styles';
import RoleDetails from './RoleDetails';
import { useViewRoleMutation } from '../../../../api/roles';
import { RoleMenu } from '../RoleMenu';
import ActionButton from '../../../../components/common/ActionButtonAndMenu/ActionButton';

const ViewRoles = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const [roleDetails, setRolesDetails] = useState({});
    const { enqueueSnackbar } = useSnackbar();

    const [viewRole, { isLoading: isViewLoading }] = useViewRoleMutation();

    useEffect(() => {
        async function fetchData() {
            const bodyFormData = new FormData();
            bodyFormData.append('id', params.id);
            try {
                const response = await viewRole(bodyFormData).unwrap();
                if (!response) return;
                if (response?.status === 'ERROR') throw new Error(response?.message);
                setRolesDetails({
                    name: 'Granted Permissions',
                    candidate: response?.grantedPermissions || [],
                    displayName: response?.secRoleInstance?.displayName || '',
                });
            } catch (error) {
                if (error?.statusCode === 400) enqueueSnackbar(error?.data?.message, { variant: 'error' });
                else
                    enqueueSnackbar(error?.message || 'Something went wrong! Position could not be fetched', {
                        variant: 'error',
                    });
            }
        }
        fetchData();
    }, [params.id]);

    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">Roles</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid
                                item
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() => navigate('/settings/roles')}
                                >
                                    Back
                                </Button>
                                <Box>
                                    <RoleMenu
                                        Component={ActionButton}
                                        row={{
                                            id: params.id,
                                            ...roleDetails,
                                        }}
                                        handleAction={() => navigate('/settings/roles')}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Typography
                                sx={{
                                    py: 2,
                                }}
                                variant="h6"
                            >
                                {roleDetails?.displayName}
                            </Typography>
                            <RoleDetails data={roleDetails} />
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default ViewRoles;
